import { atom } from "recoil";


const childAtom = atom({
    key: 'currentPersonChild',
    default: false,
});
  
export default childAtom;